import Lenis from 'lenis';
import 'lenis/dist/lenis.css';
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import "../css/app.css";
import { animate, stagger, scroll, inView, frame, time, press } from "motion";
// Put alpine last
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import focus from '@alpinejs/focus';
import persist from '@alpinejs/persist';

/* Lenis setup to smooth scrolling */
const lenis = new Lenis();

function update() {
  lenis.raf(time.now());
}

frame.update(update, true);

try {
  animate("body", { opacity: 1 });
  document.body.classList.add('motion-loaded');

  const elements = [
    "p",
    "ul:not(.tab-list)",
    ".heading", ".btn", ".cta", ".content-image",
    ".accordion", ".icon-content", ".tab-set", ".slider-set",
    ".quote", ".content-video", ".icon-wrapper", ".calendar", ".custom-table",
    ".page-header-main-photo", ".stat-ticker-group",
    ".animated", ".form-field-wrapper", ".form-btn-wrapper",
  ];

  const sections = [".section-standard", ".section-side-media"];
  const elementRevealSelectors = sections.flatMap(section => elements.map(el => `.main ${section} ${el}`)).join(", ");

  inView(".background-wrapper, .side-media-media", (element) => {
    animate(element, { opacity: 1 }, {
      duration: 0.8,
      ease: [0.3, 0.1, 0.1, 1],
    });
  }, { amount: 0.01, once: true });

  inView(elementRevealSelectors, (element) => {
    animate(element, { opacity: 1, y: 0 }, {
      duration: 0.55,
      ease: [0.3, 0.1, 0.1, 1],
      delay: 0.08,
    });
  }, { amount: 0.2, once: true });

  inView(".repeater", (repeater) => {
    const cards = Array.from(repeater.querySelectorAll('.repeater-card'));
    if (!cards.length) return;

    animate(cards, { opacity: 1, y: 0 }, {
      delay: stagger(0.10),
      duration: 0.5,
      ease: [0.3, 0.1, 0.1, 1],
    });
  }, { amount: 'some', once: true });

  // Stat ticker
  document.querySelectorAll(".stat-ticker-group").forEach((group) => {
    inView(group, (el) => {
      el.querySelectorAll(".stat-ticker-element").forEach((ticker, i) => {
        const { startval = 0, endval = 0, decimals = 0, prefix = "", suffix = "" } = ticker.dataset;
        animate(parseFloat(startval), parseFloat(endval), {
          duration: 2, ease: "circOut", delay: i * 0.3,
          onUpdate: (val) => ticker.innerText = prefix + val.toLocaleString(undefined, {
            minimumFractionDigits: +decimals, maximumFractionDigits: +decimals
          }) + suffix
        });
      });
    }, { amount: 0.3, once: true });
  });

// Mobile Menu
const menuBtn = document.querySelector(".menu-button");
const openIcon = menuBtn.querySelector(".menu-icon");
const closeIcon = menuBtn.querySelector(".close-icon");
const overlay = document.querySelector(".overlay");
const darken = document.querySelector(".darken");
const navItems = overlay.querySelectorAll(".nav-list .main-menu-top");
const transition = { duration: 0.5, ease: [0.8, 0.1, 0.1, 1] };
let isOpen = false;

// Initial states
animate(openIcon,  { scaleY: 1, opacity: 1 }, { type: false });
animate(closeIcon, { scaleY: 0, opacity: 0 }, { type: false });
animate(overlay,   { x: '100%' }, { type: false });
animate(navItems,  { opacity: 0, x: 20  }, { type: false });
animate(darken,    { opacity: 0 }, { type: false });

const toggleMenu = () => {
    isOpen = !isOpen;
    overlay.classList.toggle("open", isOpen);

    // Icons (mirror each other)
    const iconState = (forOpenIcon) => ({
        scaleY:  forOpenIcon === isOpen ? 0 : 1,
        opacity: forOpenIcon === isOpen ? 0 : 1,
    });
    animate(openIcon,  iconState(true),  { duration: 0.2 });
    animate(closeIcon, iconState(false), { duration: 0.2 });

    // Overlay & nav items
    if (isOpen) {
        animate(overlay,  { x: 0, pointerEvents: "auto" }, transition);
        animate(navItems, { opacity: 1, x: 0 }, {
            duration: 0.4,
            delay: stagger(0.03, { startDelay: 0.3 })
        });
        animate(darken,   { opacity: 0.6 }, { duration: 0.5 });
    } else {
        animate(overlay,  { x: '100%', pointerEvents: "none" }, { delay: 0.1, transition });
        animate(navItems, { opacity: 0, x: 20 }, { duration: 0.2, delay: stagger(0.03) });
        animate(darken,   { opacity: 0 }, { duration: 0.3 });
    }
};

press(menuBtn, () => {
    toggleMenu();
    animate(menuBtn, { scale: 1.05 });
    return (_, { success }) => animate(menuBtn, { scale: success ? 1.1 : 1 });
});

window.addEventListener('keydown', (e) => e.key === 'Escape' && isOpen && toggleMenu());

//CTA animation
document.querySelectorAll(".cta > .background").forEach((item) => {
    scroll(animate(item, { opacity: [0, 1, 1, 0], scale: 1.4 }), {
      target: item, offset: ["start end", "end end", "start start", "end start"]
    });
});

} catch (error) {
  console.error("Motion.dev failed to load:", error);
}

document.addEventListener('alpine:init', () => {
  
  Alpine.store('contentModal', {
    on: false,
    modalHtml: '',
    showLoading: false,   
  
    open(modalUrl, modalTitle) {      
      this.modalHtml='loading...'; 
      this.showLoading = true; 
      this.on = true;
            
      fetch(modalUrl, {
        method: 'GET',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      })
      .then(response => response.text())
      .then(text => {
        this.modalHtml = text
        this.showLoading = false;        
      })
      
    },
    
    close() {
      this.on = false;
      this.modalHtml = '';
      this.showLoading = false;   
    }
  });
});

if (typeof window.Alpine === "undefined") {
  Alpine.plugin(collapse);
  Alpine.plugin(focus);
  Alpine.plugin(persist);
  window.Alpine = Alpine;
  window.Swiper = Swiper;  
  Alpine.start();
}

// HMR
if (import.meta.hot) {
  import.meta.hot.accept(() => console.log("HMR"));
}